import { Box } from "@mui/material";
import FiltersAccordionComponent from "components/filtersMap/FiltersAccordion.component";
import GeneralKeplerMapContainer from "containers/kepler-maps/GeneralKeplerMap.container";
import React from "react";
import { propsLegendMetric } from "constants/metrics";
import LegendTemperatureComponent from "../legend/LegendTemperature.component";
import LegendMetricComponent from "../legend/LegendMetric.component";

const MapWithFiltersComponent = ({
  config,
  options,
  checked,
  onChange = () => {},
  isHeatmap = false,
  selected,
}) => {
  return (
    <Box sx={{ position: "relative" }}>
      <GeneralKeplerMapContainer config={config} />
      {isHeatmap && selected && (
        <Box sx={{ position: "absolute", top: 10, left: 10 }}>
          {selected[0]?.value === "air_temp" ? (
            <LegendTemperatureComponent />
          ) : (
            <LegendMetricComponent {...propsLegendMetric[selected[0]?.value]} />
          )}
        </Box>
      )}

      <Box
        sx={{
          marginTop: { xs: 2.5, sm: 0 },
          position: "absolute",
          top: 15,
          right: 15,
        }}
      >
        <FiltersAccordionComponent
          options={options}
          checked={checked}
          onChange={onChange}
        />
      </Box>
    </Box>
  );
};

export default MapWithFiltersComponent;
